import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "./app/ui/Toast";
import { oidcConfig } from "./auth/oidc";
import { ApiProvider } from "./api/ApiProvider";
import { queryClient } from "./api/queryClient";
import { App } from "./App";
import "./index.css";

const raiz = document.getElementById("root");
if (!raiz) throw new Error("No se encontró el elemento #root");

createRoot(raiz).render(
  <StrictMode>
    {/* Identidad primero: todo lo de dentro puede dar por hecho que sabe si hay
        sesión. Luego el cliente de API, que necesita el token de esa sesión. */}
    <AuthProvider {...oidcConfig}>
      <QueryClientProvider client={queryClient}>
        <ApiProvider>
          <BrowserRouter>
            <ToastProvider>
              <App />
            </ToastProvider>
          </BrowserRouter>
        </ApiProvider>
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>,
);
